module.exports = __webpack_public_path__ + "static/img/10004.718a9ab9.png";